var vid = document.getElementById("video");
var btn =  document.getElementById("video-play");
if(vid) {
  // if video status is changed to "paused", then change control button to "Continue Play"
  var isPlaying =true;
  vid.onpause = function() {
    isPlaying = false;
  };

  // if video status is changed to "playing", then change control button to "Stop"
  vid.onplaying = function() {
    isPlaying = true;
  };
  document.getElementById("video-play").onclick = function() {  
      if(isPlaying) {
          btn.classList.remove("play");
          btn.classList.add("pause");
          pauseVid();
      }
      else {
          btn.classList.add("play");
          btn.classList.remove("pause");
          playVid();
      }
  };  
}
function playVid() { 
  vid.play(); 
} 

function pauseVid() { 
  vid.pause(); 
} 